<template>
  <section style="padding-top: 100px;">
    <!-- "header" content other pages -->
    <!-- <header-content-geral
      :topSpace="busTopSpace"
    /> -->

    <!-- contact content -->
    <contact-frame/>
  </section>
</template>

<script>
// contact
import ContactFrame from '@/components/contact/ContactFrame'

// all
// import HeaderContentGeral from '@/components/HeaderContentGeral'

export default {
  props: {
    busTopSpace: {
      type: String, 
      required: true
    }
  },
  components: {
    // 'header-content-geral': HeaderContentGeral,
    'contact-frame': ContactFrame,
  }
}
</script>
